import { styled } from '@mui/material';

export const CardContent = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(10),
  '> div': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
}));
